import isNil from 'lodash-es/isNil';
import { useClient } from '../../../ClientProvider';
import useMutation from '../../../useMutation';
import useQuery from '../../../useQuery';
import { useArvalisSetupInfos } from './useArvalisSetupInfos';
/**
 * Create a farmer,
 * to be used on plot activation
 */
export const useArvalisFarmerCreation = (currentOrgId) => {
    const client = useClient();
    const { org, clientId, techId, farmer } = useArvalisSetupInfos({
        currentOrgId
    });
    const farmerRequest = useQuery(client.waterBalanceArvalis.getFarmer({ farmerId: farmer.id, clientId }), {
        retry: false,
        enabled: !isNil(farmer.id)
    });
    const [createArvalisFarmer] = useMutation(client.waterBalanceArvalis.addFarmer());
    return {
        addFarmer: () => {
            // If the farmer does not exist, create it
            if (farmerRequest.isFetched && !farmerRequest.data && !isNil(org)) {
                createArvalisFarmer({
                    techIds: [techId],
                    clientId: clientId,
                    farmerId: farmer.id,
                    city: farmer.city,
                    firstName: farmer.firstName,
                    lastName: farmer.lastName,
                    mail: farmer.mail,
                    zipCode: farmer.zipCode
                });
            }
        }
    };
};
